import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as PropTypes from 'prop-types';
import React from 'react';

const SelectInputMulti = ({ id, optionLabel, label, placeholder, handleChange, className, options }) => {
  return (
    <Autocomplete
      fullWidth
      className={className}
      multiple
      id={id}
      options={options}
      getOptionLabel={(option) => option[optionLabel]}
      onChange={(event, val) => {
        const ids = val.map((obj) => obj.id);

        handleChange({ target: { id, value: ids } });
      }}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          className={className}
          variant="outlined"
          label={label}
          placeholder={placeholder}
          fullWidth
        />
      )}
    />
  );
};
SelectInputMulti.propTypes = {
  id: PropTypes.string,
  optionLabel: PropTypes.node,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  className: PropTypes.object,
  options: PropTypes.node,
};

SelectInputMulti.defaultProps = {};

export default SelectInputMulti;
